export default __webpack_public_path__ + "static/media/angular.8902ebb9.svg";